import { FormField, NumberInput } from '@wix/design-system';
import React, { useRef } from 'react';

export const InputWithLabel: React.FC<{
  label: string;
  value: string;
  onChange: (value: string) => void;
  min: number;
  max: number;
  dataHook: string;
}> = ({ label, value, onChange, min, max, dataHook }) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleInputWithinBounds = (data: string | undefined) => {
    const numberValue =
      typeof data === 'string' && data.trim() !== '' && !isNaN(Number(data))
        ? parseFloat(parseFloat(data).toFixed(2))
        : NaN;

    const valueWithinBounds = (
      isNaN(numberValue) || numberValue < min ? min : numberValue > max ? max : numberValue
    ).toString();

    if (value !== valueWithinBounds) {
      onChange(valueWithinBounds);
      return;
    }
  };

  return (
    <FormField
      label={label}
      labelSize="small"
      labelPlacement="left"
      labelWidth="60%"
      inputWidth="40%"
    >
      <NumberInput
        inputRef={inputRef}
        value={value}
        onChange={(_, stringValue) => {
          onChange(stringValue);
        }}
        min={min}
        max={max}
        onBlur={e => {
          handleInputWithinBounds(e.target.value);
        }}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            handleInputWithinBounds(inputRef.current?.value);
          }
        }}
        size="small"
        dataHook={dataHook}
      />
    </FormField>
  );
};
